import requestData from "@/http/request"

export const uploadImagesRequest = files=>requestData('/Recon/recon/uploadImages','POST',{files})

export const addReconBillRequest = ({
    inquiry_id,
    brand_code,
    brand_name,
    img,
    files,
    case_number,
    plate_number,
    vin,
    model_name,
    repair_name,
    remarks,
    part_json,
    ins_inquiry_sn,
    end_time
})=>requestData('/Recon/recon/addReconBill','POST',{
    inquiry_id,
    brand_code,
    brand_name,
    img,
    files,
    case_number,
    plate_number,
    vin,
    model_name,
    repair_name,
    remarks,
    part_json,
    ins_inquiry_sn,
    end_time
})
export const getCommonBrandListRequest = ()=> requestData('/Recon/recon/getCommonBrandList')
export const brnstListByLetterRequest = p => requestData('/weChat/jnpplistbyletter?pycx='+p)
export const getReconBillListRequest = ({
    page=1,
    page_size=5,
    case_number,
    plate_number,
    vin,
    bill_sn,
    start_time,
    end_time,
    ins_name,
    repair_name,
    bill_status,
    brand_name,
    inquiry_id,
    ins_inquiry_sn,
}) => requestData('/Recon/recon/getReconBillList','GET',{
    page_size,
    page,
    case_number,
    plate_number,
    vin,
    bill_sn,
    start_time,
    end_time,
    ins_name,
    repair_name,
    bill_status,
    brand_name,
    inquiry_id,
    ins_inquiry_sn,
})
export const getMsgByVinRequest = vin=>requestData('/queryPrice/getMsgByVin','POST',{vin,plateNo:'',enquiryNo:''})
export const getInquiryInfoRequest = ({key=0,value=''})=> {
    const arr = [
        [1,'inquiry_id'],
        [2,'case_number'],
        [3,'vin'],
        [4,'plate_number']
    ]
    let findResult = arr.find(i=>i[0]===Number(key))[1];
    return requestData('/Recon/recon/getInquiryInfo','POST',{[findResult]:value})
}
export const getReconBillInfoRequest = bill_id => requestData('/Recon/recon/getReconBillInfo','POST',{bill_id})
export const statusChangeRequest = (bill_id,bill_status)=>requestData('/Recon/recon/saveReconBillStaus','POST',{bill_id,bill_status})
export const saveAppraisalBillRequest = ({bill_id,return_reason,appraisal_status,part_json='', img='', files=''})=> requestData('/Recon/recon/saveAppraisalBill','POST',{bill_id,return_reason,appraisal_status,part_json,img,files})
